import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return ($props.count && $props.count > 0)
        ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            class: _normalizeClass($setup.cn('absolute -top-1.5 -right-1.5 inline-flex items-center justify-center', 'min-w-5 h-5 px-1.5 rounded-[10px] text-xs font-medium whitespace-nowrap', $setup.variantClasses[$props.variant], $setup.props.class))
        }, _toDisplayString($props.count), 3 /* TEXT, CLASS */))
        : _createCommentVNode("v-if", true);
}
